import { getStoreId } from "$/hooks/use-store-information"
import serviceReminderQueries, {
  DEFAULT_EMAIL_FILTERS,
} from "$/lib/queries/service-reminder-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/automatic-emails/")({
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(
        serviceReminderQueries.list(storeId, DEFAULT_EMAIL_FILTERS),
      )
    }
    return {
      crumb: "alfred.pages.automaticEmails.crumbs.automaticEmails",
    }
  },
})
